import React from 'react';

import CountryProfileSection from './CountryProfileSection';

class CountryProfileSectionList extends React.Component {
  componentDidMount() {
    console.log('[DEBUG] CountryProfileSectionList mounted, received list:', this.props.list);
  }
  
  componentDidUpdate() {
    console.log('[DEBUG] CountryProfileSectionList updated, current list:', this.props.list);
  }
  renderList() {
    const list = this.props.list;

    return list.map((item, index) => {
      return (
        <CountryProfileSection
          key={ index }
          name={ item.name }
          data={ item.sub_sections }
        />
      );
    });
  }

  render() {
    return (
      <div className="country-profile-record">
        { this.renderList() }
      </div>
    );
  }
}

export default CountryProfileSectionList;



// WEBPACK FOOTER //
// ./src/components/CountryProfile/CountryProfileSecionList.js